module.exports = __webpack_public_path__ + "static/media/ic-change-direction.258facf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-change-direction.svg
// module id = 719
// module chunks = 0